import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FileInfo } from '@app/shared/types/models/files/file-info';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-file-item-thumbnail',
  templateUrl: './file-item-thumbnail.component.html',
  styleUrl: './file-item-thumbnail.component.scss',
  imports: [MatIconModule, TranslatePipe],
  // Block host so size utilities set by the parent (e.g. `w-full h-25`) size the tile.
  host: { class: 'block' }
})
export class FileItemThumbnailComponent {
  public readonly file = input<FileInfo>();
  public readonly isAvatar = input<boolean>(false);
}
